import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserHelper {

    dataSource: any[] = [];
    public userSubject = new BehaviorSubject<any>(this.dataSource);

    constructor() {
        this.userSubject.next(true)
    }
  
}